import React from "react";
import { Link } from "react-router-dom";
import { WorkflowType, GetSnowflakeJobItem } from "../types";
import { getWorkflowNavigationPrefix } from "./utils";

interface WorkflowIdCellProps {
  item: GetSnowflakeJobItem;
  workflowType: WorkflowType;
}

export const WorkflowIdCell: React.FC<WorkflowIdCellProps> = ({
  item,
  workflowType
}) => {
  const url = `${getWorkflowNavigationPrefix(workflowType)}/${encodeURIComponent(item.workflow_id)}`;
  
  return (
    <Link
      to={url}
      className="al-text-brand al-break-all cursor-pointer"
    >
      {workflowType === WorkflowType.TABLEAU ? item.tableau_dashboard_name : item.workflow_id}
    </Link>
  );
};